<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <!-- tab -->
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="btn" @click="handleBrandModal('add')">+ 添加品牌</div>
          <div class="tip">添加品牌后，请在输入框中输入品牌利润</div>
        </div>
        <div class="table-box">
          <table>
            <tr class="thead">
              <th>商品名称</th>
              <th v-for="col in bandSelected" :key="col.id">
                {{ col.name }}-利润/元
              </th>
            </tr>
            <tr v-for="row in list" :key="row.id">
              <td style="text-align: left;">{{ row.name }}</td>
              <td v-for="col in bandSelected" :key="col.id">
                <el-input
                  class="input"
                  v-model="data[col.id][row.id]"
                  placeholder="请输入利润"
                  size="small"
                ></el-input>
              </td>
            </tr>
          </table>
        </div>
        <div class="btn-box">
          <!-- <button class="cancel-btn" @click="handleCancel">取消</button> -->
          <button class="confirm-btn" @click="handleConfirm">保存</button>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="addBrandShow"
      class="dialog"
      width="450px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">
        选择品牌
      </div>
      <el-form ref="form" class="banner-form" label-width="auto">
        <el-form-item label="品牌名称：" prop="link" class="form-item">
          <el-select
            v-model="brandInfo"
            placeholder="全部"
            size="small"
            class="input"
            value-key="id"
            style="margin: 0 10px"
          >
            <el-option
              v-for="item in brandList"
              :key="item.id"
              :label="item.name"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="addBrandShow = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleBrand"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import myUtils from '../../components/common/whatever2excel';
import { role, roleMap } from '@/config.js';
export default {
  components: {
    Header
  },
  name: 'balanceRecord',
  data() {
    return {
      loading: 0, // 加载中
      list: [], // 列表
      title: {
        // 页面标题
        firstTitile: '商品管理',
        secondTitle: '批量设置商品品牌'
      },
      brandList: [],
      brandId: null,
      addBrandShow: false,
      brandInfo: {},
      bandSelected: [],
      templateData: {},
      data: {

      }
    };
  },

  mounted() {
    this.getBrandList();
    let query = this.$route.query;
    if(query.list){
        this.list = JSON.parse(query.list);
    };
    let obj = {};
    this.list.forEach(item => {
        obj[item.id] = null;
    });
    this.templateData = obj;
  },
  computed: {},
  methods: {
      // 获取品牌列表
    getBrandList() {
        this.loading++;
        this.httpGet(this.$root.getBrandList, {
        }).then(
        (res) => {
            this.loading--;
            this.brandList = res.list;
        },
        (res) => {
            this.loading--;
            this.$message.error(res);
        }
        );
    },
    getBrandMap(bid){
        this.loading++;
        this.httpPost(this.$root.getBrandMap, {
            gidList: this.list.map(item => item.id),
            bidList: [bid],
        }).then(
        (res) => {
            this.loading--;
            let obj = {};
            res.list.forEach(item => {
                obj[item.gid] = item.profit;
            });
            for(let key in this.data[bid]){
                if(obj[key]){
                    this.data[bid][key] = obj[key];
                }
            }
        },
        (res) => {
            this.loading--;
            this.$message.error(res);
        }
        );
    },
    addBrand(){
        this.brand.push({profit: null, bid: null});
    },
    handleBrandModal(type) {
        this.brandInfo = {};
        this.addBrandShow = true;
    },
    handleBrand(){
        if(!this.brandInfo.id){
            this.$message.warning('请选择品牌');
            return;
        };
        if(this.data[this.brandInfo.id]){
            this.$message.warning('请不要重复选择品牌');
            return;
        };
        this.bandSelected.push(this.brandInfo);
        // this.data[this.brandInfo.id] = {...this.templateData};
        this.$set(this.data, this.brandInfo.id, {...this.templateData});
        this.getBrandMap(this.brandInfo.id);
        this.addBrandShow = false;
        // console.log(this.bandSelected, this.data);
    },
    handleConfirm(){
        // console.log(this.data);
        let list = [];
        for(let bid in this.data){
            for(let gid in this.data[bid]){
                let item = this.data[bid][gid];
                list.push({
                    gid: +gid,
                    bid: +bid,
                    profit: +item || 0,

                })
            }
        };
        this.loading++;
        this.httpPost(this.$root.batchUpdateBrand, {
            list
        }).then(
        (res) => {
            this.loading--;
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.$router.push({
                name: 'goodsManage'
            });
        },
        (res) => {
            this.loading--;
            this.$message.error(res);
        }
        );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.page-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 10px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;
      position: relative;

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        // margin: 16px 0;
      }

      .tip{
        word(12px, btn-color);
        margin-left: 12px;  
      }

      // 表格按钮
      .table-btn {
        // width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
        padding: 0 8px;
      }

      .filter-item {
        margin-right: 12px;
      }

      .select, .input {
        width: 160px;
      }

      .date-input {
        width: 360px;
      }

      .btn-box {
        margin: 0;
      }

      .table {
        margin-top: 24px !important;
      }

      .table-box{
        width: 100%;
        margin-top: 12px;
        overflow-x: auto;
        padding-bottom: 100px;
        table{
            border: 1px solid #E8E8E8;
            border-bottom-width: 0;
        }
        tr{
            // padding: 10px;
            border-bottom: 1px solid #E8E8E8;
            td, th{
                width: 250px;
                min-width: 250px;
                height: 60px;
                box-sizing: border-box;
                padding: 10px 16px;
                word(14px, #333);
                font-weight: normal;
                text-align: center;
            }
            &.thead{
                background: #F6F6F6;
                td, th{
                    width: 250px;
                    min-width: 250px;
                    height: 54px;
                }   
            }
        }  
      }
    }
  }
  .banner-form {
    margin-top: 20px;
    margin-bottom: 20px;
    flex-y(center);
  //   padding-left: 60px;

    .sort-tip {
      word(14px, #c8c8c8);
      line-height: 20px;
    }
  }
  .btn-box {
    background: white;
    width: 100%;
    flex-x(center);
    height: 100px !important;
    flex-shrink: 0;
    position: absolute;
    bottom: 0;
    left: 0;
    // padding-bottom: 48px;

    .cancel-btn {
      width: 96px;
      height: 40px;
      cancel-btn();
      // border-radius: 23px;
    }

    .confirm-btn {
      width: 96px;
      height: 40px;
      margin-left: 20px;
      confirm-btn();
    }
  }
}
</style>
